import React, { useState } from 'react';
import { useApp } from '../../contexts/AppContext';
import './Forms.css';

interface SectionFormProps {
  bookId: string;
  bookTitle: string;
  onCancel: () => void;
}

export const SectionForm: React.FC<SectionFormProps> = ({ bookId, bookTitle, onCancel }) => {
  const { createSection, sectionTypes, sectionThemes } = useApp();
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    section_number: '',
    section_type_id: '',
    theme_id: '',
    show_in_toc: true,
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createSection(bookId, formData);
      onCancel(); // Close the form on success
    } catch (error) {
      // Error is handled in context
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    const type = (e.target as HTMLInputElement).type;
    const checked = (e.target as HTMLInputElement).checked;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  return (
    <div className="form-view">
      <div className="content-header">
        <h2>Add New Section</h2>
        <p>Add a section to: {bookTitle}</p>
      </div>
      <div className="content-body">
        <div className="form-container">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Title *</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Subtitle</label>
              <input
                type="text"
                name="subtitle"
                value={formData.subtitle}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Section Number</label>
              <input
                type="text"
                name="section_number"
                value={formData.section_number}
                onChange={handleChange}
                placeholder="e.g., 1.1"
              />
            </div>
            <div className="form-group">
              <label>Section Type</label>
              <select
                name="section_type_id"
                value={formData.section_type_id}
                onChange={handleChange}
              >
                <option value="">Select a type...</option>
                {sectionTypes.map(type => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Theme</label>
              <select
                name="theme_id"
                value={formData.theme_id}
                onChange={handleChange}
              >
                <option value="">Select a theme...</option>
                {sectionThemes.map(theme => (
                  <option key={theme.id} value={theme.id}>
                    {theme.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  name="show_in_toc"
                  checked={formData.show_in_toc}
                  onChange={handleChange}
                />
                {' '}Show in Table of Contents
              </label>
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                Create Section
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};